import classnames from 'classnames';
import { useNoFeeForTopUpNewInvestor } from '@/containers/NoFeeForTopUpNewInvestor';
import {
  useIncreasedIncome,
  LAYOUT_TYPE as LayoutIncreased,
} from '@/containers/IncreasedIncome';
import {
  useEveryFiveGroupA,
  LAYOUT_TYPE as LayoutEveryFive,
} from '@/containers/EveryFiveGroupA';
import { Slider } from './slider';
import s from './index.module.scss';

export const OffersBanner = ({ hideNavigation }) => {
  const banners = [];

  const everyFiveGroupABanner = useEveryFiveGroupA({
    layout: LayoutEveryFive.investing_slider_card,
  });
  const increasedIncomeBanner = useIncreasedIncome({
    layout: LayoutIncreased.investing_slider_card,
  });
  const noFeesForNewTopUp = useNoFeeForTopUpNewInvestor();

  noFeesForNewTopUp && banners.push(noFeesForNewTopUp);
  everyFiveGroupABanner && banners.push(everyFiveGroupABanner);
  increasedIncomeBanner && banners.push(increasedIncomeBanner);

  return banners.length ? (
    banners.length > 1 ? (
      <Slider slides={banners} hideNavigation={hideNavigation} />
    ) : (
      <div className={classnames(s.single, hideNavigation && s.hide_nav)}>
        {banners[0]}
      </div>
    )
  ) : null;
};
